import React from 'react';

import { AuthForm } from '../../../../entities/auth/ui/AuthForm';
import styles from './Login.module.css';

export const LoginPage = () => {
  return (
    <div className={styles.layout}>
      <div className={styles.header}>
        <div className={styles.title}>{process.env.REACT_APP_WEBSITE_NAME}</div>
      </div>
      <AuthForm />
    </div>
  );
};
